import { lazyWithPreload, createComponentRegistry } from 'copilot-toolkit/js/custom-components';

// CONNECT_INBOX_CARD / INBOX_SYNC_SETUP_CARD are added to the backend enum in the same change set;
// keep them as a temporary union until the generated OnboardingCustomComponentType TS type picks
// up the new values, then remove this union (see breeze-onboarding-components/README.md step 3).
const NAMESPACE = 'CONVERSATIONAL_ONBOARDING';
export const onboardingRegistryEntry = createComponentRegistry(NAMESPACE, {
  GTKM_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/GetToKnowMeCard')),
  STEP_INDICATOR: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/StepIndicator/StepIndicator')),
  CONTACTS_TABLE: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/prospecting-agent/ContactTable')),
  TARGET_MARKET_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/segments/TargetMarketCard')),
  AI_LINK_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/segments/AILinkCard')),
  SEQUENCES_PREVIEW: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/sequences/SequencesPreview')),
  SEGMENT_PREVIEW: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/segments/SegmentPreview')),
  GENERIC_JOURNEY_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/GenericJourneyCard')),
  CONNECT_INBOX_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/data-sync/ConnectInboxCard')),
  INBOX_SYNC_SETUP_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/data-sync/InboxSyncSetupCard')),
  RECOMMENDED_NEXT_TASK: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/RecommendedNextTask'))
});